//import liraries

import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
const useStyles = CreateResponsiveStyle(
  {
    container: {
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      marginTop: 10,
      position: "relative",
    },
    modal: {
      minHeight: 200,
      width: 300,
    },
    addIconBox:{
      width: 135,
      height: 135,
      fontSize: "1rem",
      color: "white",
      backgroundColor: "#fff",
      borderRadius: 10,
      borderWidth: 1,
      borderStyle: "dashed",
      borderColor: "#ccd0d5",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
    backBtnWidget: {
      flexDirection: "row",
      alignItems: "center",
    },
    widgetTitle: {
      color: "#999",
      fontFamily: "Inter",
      fontSize: 20,
      marginVertical: 10,
    },
    previewImageView: {
      height: 120,
      width: 120,
    },
    textStyle: {
      color: "#02122c",
      fontFamily: "Inter",
      fontSize: 13,
    },
    text: {
      fontSize: 30,
      color: "white",
    },
    stepWidget: {
      backgroundColor: "#fff",
      borderRadius: 10,
      padding: 10,
      marginTop: 10,
      width: "100%",
      marginLeft: 30,
      minHeight: 300,
      position: "relative",
    },
    rcInputViewStyle: { width: 300 },
    addVehicleErrorContainer: {
      backgroundColor: "#fff",
      borderRadius: 10,
      padding: 10,
      marginTop: 0,
      width: "90%",
      marginLeft: 20,
      position: "relative",
    },
    stepText: {
      color: "#c32b2c",
      fontFamily: "Inter",
      fontSize: 14,
    },
    stepTitle: {
      color: "#5f5f5f",
      fontFamily: "Inter",
      fontSize: 16,
      marginVertical: 8,
    },
    stepDesk: {
      color: "#757575",
      fontFamily: "Inter",
      fontSize: 16,
      marginBottom: 8,
      width: "80%",
    },
    inputBox: {
      flexDirection: "row",
      alignItems: "center",
      marginVertical: 10,
    },
    btnBox: {
      alignSelf: "center",
      marginHorizontal: 10,
      marginTop: -15,
    },
    step1: {
      // flex: 0.4,
      minHeight: 100,
      paddingLeft: 28,
      marginLeft: 10,
    },
    step2: {
      marginTop:50,
      flex: 0.5,
      minHeight: 200,
    },
    tableData: {
      backgroundColor: "rgba(176, 176, 176, 0.2)",
      borderRadius: 5,
      padding: 10,
      marginTop: 10,
      width: "100%",
    },
    tableRow: {
      flexDirection: "row",
      justifyContent: "space-around",
      marginVertical: 3,
    },
    tableColumn: {
      color: "#757575",
      fontFamily: "Inter",
      fontSize: 13,
    },
    warningBox: {
      flexDirection: "row",
      alignItems: "center",
      marginVertical: 14,
      width: "70%",
    },
    warningText: {
      color: "#949494",
      fontFamily: "Inter",
      fontSize: 11,
      marginLeft: 6,
    },
    imageStyle: {
      width: 135,
      height: 135,
      fontSize: "1rem",
      color: "white",
      backgroundColor: "#fff",
      borderRadius: 10,
      borderWidth: 1,
      borderStyle: "dashed",
      borderColor: "#ccd0d5",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
    buttonContainerStyle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      alignSelf: "center",
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#16ac39",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    buttonContainerStyle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#16ac39",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    buttonAddVehicle: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      marginBottom: 30,
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#bd2d37",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    buttonAddVehicleDisable: {
      alignSelf: "flex-end",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 20,
      marginBottom: 30,
      width: 200,
      height: 35.7,
      borderRadius: 18,
      backgroundColor: "#e0e2e5",
      shadowColor: "rgba(0, 0, 0, 0.08)",
      shadowOffset: {
        width: 0,
        height: 10,
      },
      shadowRadius: 5,
      shadowOpacity: 1,
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 10,
    },
    rcUploadWidget: {},
    rcText: {
      color: "#5f5f5f",
      fontFamily: "Inter",
      fontSize: 16,
      fontWeight: 600,
      marginVertical: 10,
    },
    fileSizeText: {
      color: "#757575",
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 300,
      marginBottom: 10,
    },
    addImageWidget: {
      alignItems: "center",
    },
    addIcon: {
      fontSize: 20,
      color: "#ccd0d5",
    },
    addText: {
      color: "#02122c",
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 500,
      opacity: 0.5,
    },
    fileName: {
      color: "#02122c",
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: 500,
      opacity: 0.5,
      width: 100,
      overflow: "hidden",
    },
    addBackImage: {
      marginLeft: 50,
    },
    closeIconLink: {
      position: "absolute",
      top: -12,
      right: -20,
      zIndex: 9,
    },
    closeIcon: {
      width: 89,
      height: 89,
    },
    iconSuccess: {
      width: 18,
      height: 18,
    },
    wid40: {
      width: "40%",
    },
    wid5: {
      width: "5%",
    },
    wid50: {
      width: "50%",
    },
    statusColor: {
      color: "#c32b2c",
    },
  },

  {
    [DEVICE_SIZES.XL]: {
      container: {},
      stepWidget: {
        flexDirection: "row",
        width: "95%",
        alignSelf: "flex-start",
      },
    },
    [DEVICE_SIZES.LG]: {
      stepWidget: {
        flexDirection: "column",
        width: "62%",
        alignSelf: "flex-start",
      },
      step2: {
        marginTop: 30,
        paddingLeft: 30,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flexDirection: "column",
      },
      stepWidget: {
        flexDirection: "column",
        maxWidth: 700,
        width: "60%",
        alignSelf: "flex-start",
      },
      tableData: {
        width: "50%",
      },
      inputBox: {
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: 300,
      },
      btnBox: {
        marginTop: 0,
        marginBottom: 10,
      },
      step1: {
        marginBottom: 30,
      },
      step2: {
        marginTop: 30,
        paddingLeft: 30,
      },
      warningBox: {
        marginVertical: 20,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        width: "100%",
        marginTop: 10,
        height: "100%",
        position: "relative",
        marginBottom: 80,
      },
      modal: {
        minHeight: 200,
        width: 300,
      },
      backBtnWidget: {
        flexDirection: "row",
        alignItems: "center",
      },
      widgetTitle: {
        color: "#999",
        fontFamily: "Inter-Regular",
        fontSize: 14,
        marginVertical: 10,
      },
      textStyle: {
        color: "#02122c",
        fontFamily: "Inter-Regular",
        fontSize: 13,
      },
      text: {
        fontSize: 30,
        color: "white",
      },
      rcInputViewStyle: { width: 230 },
      stepWidget: {
        backgroundColor: "#fff",
        borderRadius: 10,
        paddingVertical: 10,
        marginTop: 10,
        width: "100%",
        marginLeft: 0,
        minHeight: 300,
        position: "relative",
        flexDirection: "column",
      },
      addVehicleErrorContainer: {
        backgroundColor: "#fff",
        borderRadius: 10,
        padding: 10,
        marginTop: 0,
        width: "90%",
        marginLeft: 20,
        position: "relative",
      },
      stepText: {
        color: "#757575",
        fontFamily: "Inter-Regular",
        fontSize: 15,
        fontWeight: "300",
        letterSpacing: 0.9,
      },
      stepTitle: {
        color: "#5f5f5f",
        fontFamily: "Inter-Regular",
        fontSize: 17,
        marginVertical: 8,
        fontWeight: "bold",
        marginRight: 10,
      },
      stepDesk: {
        color: "#757575",
        fontFamily: "Inter-Regular",
        fontSize: 12,
        marginBottom: 8,
        width: "80%",
      },
      inputBox: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 10,
      },
      btnBox: {
        alignSelf: "center",
        marginHorizontal: 10,
        marginTop: -15,
      },
      step1: {
        // backgroundColor:'green',
        // flex: 0.4,
        width: "100%",
        minHeight: 200,
        paddingLeft: 28,
        marginLeft: 10,
      },
      step2: {
        marginTop: 40,
        paddingLeft: 40,
        width: "100%",
        minHeight: 200,
      },
      tableData: {
        backgroundColor: "rgba(176, 176, 176, 0.2)",
        borderRadius: 5,
        padding: 10,
        marginTop: 10,
        width: "90%",
      },
      tableRow: {
        flexDirection: "row",
        justifyContent: "space-around",
        marginVertical: 3,
      },
      tableColumn: {
        color: "#757575",
        fontFamily: "Inter-Regular",
        fontSize: 14,
      },
      warningBox: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 14,
        width: "70%",
      },
      warningText: {
        color: "#949494",
        fontFamily: "Inter-Regular",
        fontSize: 11,
        marginLeft: 6,
      },
      imageStyle: {
        width: 95,
        height: 95,
        fontSize: "1rem",
        color: "white",
        backgroundColor: "#fff",
        borderRadius: 10,
        borderWidth: 1,
        borderStyle: "dashed",
        borderColor: "#ccd0d5",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      },
      previewImageView: {
        height: 95,
        width: 95,
      },
      buttonContainerStyle: {
        alignSelf: "flex-end",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        alignSelf: "center",
        width: 200,
        height: 35.7,
        borderRadius: 18,
        backgroundColor: "#16ac39",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      buttonContainerStyle: {
        alignSelf: "flex-end",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        width: 200,
        height: 35.7,
        borderRadius: 18,
        backgroundColor: "#16ac39",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      buttonAddVehicle: {
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 30,
        marginRight: 30,
        width: 200,
        height: 37,
        borderRadius: 18,
        backgroundColor: "#bd2d37",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      buttonAddVehicleDisable: {
        alignSelf: "center",
        alignItems: "center",
        justifyContent: "center",
        marginTop: 20,
        marginBottom: 30,
        width: 200,
        height: 35.7,
        borderRadius: 18,
        backgroundColor: "#e0e2e5",
        shadowColor: "rgba(0, 0, 0, 0.08)",
        shadowOffset: {
          width: 0,
          height: 10,
        },
        shadowRadius: 5,
        shadowOpacity: 1,
      },
      overlayViewStyle: {
        position: "absolute",
        zIndex: 9999,
        backgroundColor: "rgba(52,52,52,0.9)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        borderRadius: 10,
      },
      rcUploadWidget: {},
      rcText: {
        color: "#5f5f5f",
        fontFamily: "Inter-Regular",
        fontSize: 16,
        fontWeight: "600",
        marginVertical: 10,
      },
      fileSizeText: {
        color: "#757575",
        fontFamily: "Inter-Regular",
        fontSize: 12,
        fontWeight: "300",
        marginBottom: 10,
      },
      addImageWidget: {
        alignItems: "center",
      },
      addIcon: {
        fontSize: 20,
        color: "#ccd0d5",
      },
      addText: {
        color: "#02122c",
        fontFamily: "Inter-Regular",
        fontSize: 12,
        fontWeight: "500",
        opacity: 0.5,
      },
      fileName: {
        color: "#02122c",
        fontFamily: "Inter-Regular",
        fontSize: 12,
        fontWeight: "500",
        opacity: 0.5,
        width: 100,
        overflow: "hidden",
      },
      addBackImage: {
        marginLeft: 50,
      },
      closeIconLink: {
        position: "absolute",
        top: -12,
        right: -20,
        zIndex: 9,
      },
      closeIcon: {
        width: 89,
        height: 89,
      },
      iconSuccess: {
        width: 18,
        height: 18,
        marginLeft: 0,
      },
      wid40: {
        width: "30%",
      },
      wid5: {
        width: "2%",
      },
      wid50: {
        width: "50%",
      },
      statusColor: {
        color: "#c32b2c",
      },

      //},
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flexDirection: "column",
      },
      stepWidget: {
        flexDirection: "column",
        width: "70%",
        alignSelf: "flex-start",
      },
      tableData: {
        width: "50%",
      },
      step2: {
        marginTop: 30,
        paddingLeft: 30,
      },
    },
  }
);
export default useStyles;